import { storage } from '@/helpers/storage'
import { StorageKeys } from '@/helpers/storage.keys'

export type UpgradePromptState = 'pending' | 'shown'

/**
 * Get the current upgrade prompt state.
 *
 * `null` means neither has happened yet.
 */
export function getUpgradePromptState(): UpgradePromptState | null {
  return storage.getItem(
    StorageKeys.upgradePromptState,
  ) as UpgradePromptState | null
}

export function setUpgradePromptState(state: UpgradePromptState): void {
  storage.setItem(StorageKeys.upgradePromptState, state)
}

export function clearUpgradePromptState(): void {
  storage.removeItem(StorageKeys.upgradePromptState)
}
